export const track = (event, props = {}) => {
  try {
    window.posthog?.capture(event, props);
  } catch {
    /* analytics must never break UX */
  }
};
